module.exports = __webpack_public_path__ + "static/media/MY-MASA.85373f78.jpg";